import React from "react";

interface BookingStepsIndicatorProps {
  currentStep: number;
  totalSteps?: number;
}

const BookingStepsIndicator: React.FC<BookingStepsIndicatorProps> = ({
  currentStep,
  totalSteps = 3,
}) => {
  const steps = Array.from({ length: totalSteps }, (_, index) => index + 1);

  return (
    <div className="flex items-center justify-center mb-12" aria-label="Booking steps">
      {steps.map((step) => (
        <React.Fragment key={step}>
          <div
            className={`flex items-center justify-center w-10 h-10 rounded-full font-semibold ${
              step <= currentStep ? "bg-primary-600 text-white" : "bg-gray-300 text-gray-600"
            }`}
          >
            {step}
          </div>
          {step < totalSteps && (
            <div
              className={`w-24 h-1 mx-2 ${step < currentStep ? "bg-primary-600" : "bg-gray-300"}`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default BookingStepsIndicator;
